{
  "missed": "Missed",
  "dashboard": {
    "title": "Service overview",
    "intro": "What needs a team, a decision or an invoice today.",
    "strip": "Service figures",
    "actions": {
      "schedule": "Schedule",
      "newJob": "New service job"
    },
    "tiles": {
      "awaiting": "Awaiting a visit",
      "awaitingDetail": "Jobs with no visit booked",
      "today": "Today's visits",
      "todayDetail_one": "{{n}} team out",
      "todayDetail_other": "{{n}} teams out",
      "todayNone": "No visits booked today",
      "followUps": "Follow-up requests",
      "followUpsDetail": "Awaiting approval",
      "unfinished": "Visited, work left",
      "unfinishedDetail": "Next visit booked or still to book",
      "ready": "Ready to invoice",
      "readyDetail": "Completed work not yet invoiced",
      "collections": "Collections to verify",
      "collectionsDetail": "reported",
      "planned": "Planned, to schedule",
      "plannedDetail": "Planned jobs not fully booked",
      "plannedNone": "Every planned job is booked"
    },
    "overdue": {
      "none": "Nothing is overdue.",
      "count_one": "{{n}} job overdue",
      "count_other": "{{n}} jobs overdue",
      "why": "A visit was missed or the promised date has passed.",
      "open": "Show overdue jobs"
    },
    "today": {
      "title": "Today's visits",
      "openSchedule": "Open the schedule",
      "empty": "No visits today",
      "emptyBody": "Visits booked for today appear here, grouped by team.",
      "scheduleVisit": "Schedule a visit",
      "visits_one": "{{n}} visit",
      "visits_other": "{{n}} visits",
      "lead": "Lead: {{name}}",
      "noLead": "No lead yet"
    },
    "decisions": {
      "title": "Waiting for you",
      "followUps_one": "{{n}} follow-up to approve",
      "followUps_other": "{{n}} follow-ups to approve",
      "collections_one": "{{n}} payment to verify",
      "collections_other": "{{n}} payments to verify",
      "after": "after visit {{n}}",
      "proposed": "proposes {{date}}",
      "noDate": "no date proposed",
      "approve": "Approve",
      "approveLabel": "Approve the request on {{number}}",
      "return": "Return",
      "returnLabel": "Return the request on {{number}}",
      "verify": "Verify",
      "verifyLabel": "Verify the payment on {{number}}",
      "allFollowUps": "All requests",
      "allCollections": "All collections",
      "collectedBy": "{{method}} · {{name}}"
    }
  },
  "board": {
    "title": "Schedule",
    "intro": "Seven days of visits by team, from today. Click a team’s day or drag a job onto it to book a visit; drag a visit to move it.",
    "introReadOnly": "Seven days of visits by team, from today.",
    "awaitingList": "Jobs awaiting a visit",
    "previousWeek": "Previous week",
    "today": "Today",
    "nextWeek": "Next week",
    "holiday": "Holiday:",
    "dayOff": "Day off",
    "book": {
      "title": "Book {{team}} on {{day}}",
      "short": "Book",
      "filter": "Filter jobs",
      "waiting": "Jobs awaiting a visit",
      "noJobs": "No jobs are waiting for a visit.",
      "noMatch": "No waiting job matches.",
      "newJob": "New job here…"
    },
    "weekRange": "{{from}} – {{to}}",
    "team": "Team",
    "allTeams": "All teams",
    "gridLabel": "Visits by team and day",
    "visitsCount_one": "{{n}} visit",
    "visitsCount_other": "{{n}} visits",
    "dragHint": "Nothing changes until you confirm it in the scheduling dialog. Only visits not yet started can be moved.",
    "dayPicker": "Day",
    "noVisitsThatDay": "No visits",
    "noTeams": "No field service teams yet",
    "noTeamsBody": "Visits are booked for a team that makes service visits. Create one, or mark a team as making service visits, with its members and visit leads.",
    "manageTeams": "Manage teams",
    "unscheduled": {
      "title": "Awaiting a visit",
      "hint": "Most urgent first. Drag a job onto the board, or use Schedule.",
      "hintReadOnly": "Most urgent first.",
      "showAll": "Show all {{n}} in Service jobs",
      "empty": "Every open job has a visit booked.",
      "preferred": "Prefers {{date}}",
      "scheduleJob": "Schedule a visit for {{number}}",
      "schedule": "Schedule",
      "noTeam": "No team yet",
      "requestsTitle": "Requests awaiting a visit"
    },
    "followUps": {
      "title": "Follow-up requests",
      "hint": "Approve one to book the follow-up visit, or return it with a note.",
      "hintReadOnly": "A service manager approves or returns them.",
      "openQueue": "Open the follow-up queue",
      "empty": "No follow-up requests await a decision.",
      "proposed": "Proposed {{date}}",
      "noDate": "No date proposed",
      "requested": "{{name}} · {{when}}"
    },
    "introTouch": "Seven days of visits by team, from today. Tap Schedule on a waiting job to book it.",
    "planned": {
      "title": "Planned, to schedule",
      "hint": "By due date, per contract and site. Drag a job onto the board, or use Schedule.",
      "hintReadOnly": "By due date, per contract and site.",
      "showAll": "Show all {{n}} in Service jobs",
      "empty": "Every planned job has its visits booked.",
      "due": "Due {{date}}",
      "overdue": "Overdue since {{date}}",
      "partScheduled": "Part booked · next {{date}}",
      "scheduleJob": "Schedule a visit for {{number}}",
      "scheduleNext": "Schedule next part",
      "assets_one": "{{n}} asset",
      "assets_other": "{{n}} assets",
      "jobs_one": "{{n}} planned job",
      "jobs_other": "{{n}} planned jobs",
      "checksLeft_one": "{{n}} check left",
      "checksLeft_other": "{{n}} checks left",
      "checked": "{{checked}} / {{total}} checked",
      "workDays_one": "about {{n}} day of work",
      "workDays_other": "about {{n}} days of work",
      "workHours_one": "about {{n}} hour of work",
      "workHours_other": "about {{n}} hours of work"
    }
  },
  "followUps": {
    "title": "Follow-up requests",
    "intro": "Requests for another visit after an attended one. Approve to book the visit, or return it with a note.",
    "introReadOnly": "Requests for another visit after an attended one. A service manager approves or returns them.",
    "openSchedule": "Open the schedule",
    "views": "Follow-up requests by status",
    "empty": {
      "PENDING": "No follow-up requests await approval",
      "RETURNED": "No returned requests",
      "APPROVED": "No approved requests yet",
      "WITHDRAWN": "No withdrawn requests"
    },
    "emptyBody": {
      "PENDING": "When work is left after a visit, the technician’s request for another visit appears here for your approval.",
      "RETURNED": "Requests returned to the technician with a note wait here until they resubmit or withdraw them.",
      "APPROVED": "An approved request books the follow-up visit on the schedule.",
      "WITHDRAWN": "Requests the technician withdrew are kept here."
    },
    "cardLabel": "Follow-up request on {{number}}",
    "requestedBy": "Requested by {{name}} · {{when}}",
    "fields": {
      "fromVisit": "After"
    },
    "noDate": "No date proposed",
    "decision": {
      "PENDING": "Earlier decision",
      "APPROVED": "Approved",
      "RETURNED": "Returned",
      "WITHDRAWN": "Withdrawn"
    },
    "decidedBy": "{{name}} · {{when}}",
    "openVisit": "Open the follow-up visit",
    "return": "Return",
    "approve": "Approve",
    "returnLabel": "Return the request on {{number}}",
    "approveLabel": "Approve the request on {{number}}",
    "needsApprover": "Awaiting a service manager's decision.",
    "partsTask": "Create a task for the parts",
    "partsTaskLabel": "Create a task for the parts of {{number}}",
    "partsTaskTitle": "Parts for {{number}}: {{what}}",
    "approveAsLabel": "Approve the request on {{number}} as proposed",
    "change": "Change…",
    "changeLabel": "Change the visit before approving the request on {{number}}",
    "booked": "Follow-up booked: {{team}}, {{date}}"
  },
  "collections": {
    "title": "Collections",
    "intro": "Money technicians report collecting. An invoice's balance changes only when you verify the collection: that records the receipt.",
    "views": "Collections by status",
    "balance": "Balance",
    "empty": {
      "REPORTED": "Nothing to verify",
      "VERIFIED": "No verified collections yet",
      "REJECTED": "No rejected collections"
    },
    "emptyBody": {
      "REPORTED": "When a technician reports money collected on a job, it waits here for you to verify it.",
      "VERIFIED": "Verified collections, with the receipt each one became, are listed here.",
      "REJECTED": "Collections you reject are kept here with the reason; the technician is told."
    },
    "panel": {
      "title": "Collection on {{number}}",
      "loading": "Collection",
      "visit": "Visit",
      "openVisit": "Open the visit",
      "number": "Number",
      "balanceNote": "The invoice's balance changes only when this collection is verified."
    },
    "decided": {
      "verified": "Verified by {{name}} · {{when}}",
      "rejected": "Rejected by {{name}} · {{when}}",
      "receipt": "Receipt"
    },
    "decision": {
      "title": "Verify the money",
      "how": "How to verify",
      "notAllowed": "Only users who verify payments can verify or reject this collection.",
      "salesOff": "Sales is not enabled for your company: verifying records a receipt, so collections can't be verified now. You can still reject a collection that wasn't received.",
      "create": "Record a receipt",
      "createBody": "A receipt for the amount, applied to the invoice.",
      "link": "Use a recorded receipt",
      "linkBody": "The money is already on a receipt for this customer (a bank transfer, say).",
      "account": "Received into",
      "accountHint": "The default account for the method, from the payment settings.",
      "accountsUnavailable": "The cash and bank accounts can't be listed for you. Ask an administrator for access to them.",
      "noAccounts": "No active cash or bank account yet.",
      "chooseAccount": "Choose the account the money went into.",
      "receiptDate": "Receipt date",
      "dateHint": "The day it was collected.",
      "chooseDate": "Choose the receipt date.",
      "receipt": "Receipt",
      "receiptHint": "Posted receipts of this customer, newest first.",
      "noReceipts": "This customer has no posted receipt.",
      "chooseReceipt": "Choose the receipt that holds this money.",
      "receiptOption": "{{number}} · {{date}} · {{amount}} (unapplied {{credit}})",
      "reject": "Reject",
      "verifyCreate": "Verify and record receipt",
      "verifyLink": "Verify with this receipt",
      "receiptsUnavailable": "The customer’s receipts could not be loaded.",
      "chequeMissing": "Enter the cheque’s number and the bank it is drawn on.",
      "noneFits": {
        "title": "No account here can receive this payment",
        "cash": "Cash goes only into a cash account, and a till’s drawer takes only that till’s sales.",
        "other": "A card payment or a transfer goes into a bank, card or wallet account, not a cash account.",
        "add": "Add one: open “{{field}}” and choose “{{action}}”.",
        "ask": "Ask someone who manages the cash and bank accounts to add one."
      }
    },
    "toast": {
      "verified": "Collection verified",
      "verifiedWith": "Collection verified · receipt {{number}}",
      "rejected": "Collection rejected"
    },
    "reject": {
      "title": "Reject this collection?",
      "body": "No receipt is recorded and the invoice stays as it is. The technician is told why.",
      "reason": "Reason",
      "required": "Say why it is rejected.",
      "confirm": "Reject collection"
    },
    "introReadOnly": "Money you reported collecting. An accountant verifies each one; the invoice’s balance changes then.",
    "emptyBodyReadOnly": "Payments you record on a visit appear here until they are verified."
  }
}
